import { Model, NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import { HttpResponseStatusCodeEnum } from '../../Models/HttpResponseStatusCodeEnum';
import StaticServiceProviderModel from '../../Models/StaticServiceProviderModel';
import { TextConstants } from '../../TextConstants';
import { AppService, Types } from '../../../App/Services/AppService';
import ScheduleWACCommand from '../../../Home/Models/Queries/ScheduleWACForRawImportLogIDCommand';
import ScheduleInterceptionCommand from '../../../Home/Models/Queries/ScheduleInterceptionCommand';
import DateTimeHelper from '../Helpers/DateTimeHelper';
import { StaticDataTypes } from '../../../Maintenance/StaticData/StaticDataTypes';
import InstrumentSearchLookup from '../../../DataInterception/InstrumentMapping/Models/InstrumentSearchLookup';

@NeoModel
export default class RunInterceptionComponentVM extends Views.ViewModelBase {

    constructor(
        public taskRunner = AppService.get(Types.Neo.TaskRunner),
        public homeApiClient = AppService.get(Types.ApiClients.HomeApiClient),
        public clientAccountApiClient = AppService.get(Types.ApiClients.ClientAccountApiClient),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        private staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache))
        {
            super(taskRunner);
        }

    public selectedServiceProvider = new StaticServiceProviderModel();
    public scheduleProcessCommand = new ScheduleWACCommand();
    public runInterception: boolean = false;
    public runBookCostCalc: boolean = false;

    public instruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public filteredInstruments: Model.PlainObject<InstrumentSearchLookup>[] = [];

    public t1: Date = DateTimeHelper.getPreviousBusinessDay();

    public async initialise() {
        await this.populateInstruments();
    }

    public async populateInstruments() {
        this.instruments = await this.staticDataCache.instruments.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.description!.localeCompare(y.description!)));
        this.filteredInstruments = this.instruments.sort((x, y) => x.isin!.localeCompare(y.isin!)).slice(0, 10);
    }

    public setProcess() {
        if (this.scheduleProcessCommand.meta.processToBeRun.value === TextConstants.Buttons.BookCostCalculation)
        {
            this.setBookCostCalcToTrue();
        }
        if (this.scheduleProcessCommand.meta.processToBeRun.value === TextConstants.Buttons.RunInterception)
        {
            this.setInterceptionToTrue();
        }
    }

    public async runProcess(interceptionProcessName: string = "") {
        if (this.runInterception) {
            var interceptionCommand = this.mapWACCommandToInterceptionCommand(interceptionProcessName);
            await this.scheduleInterceptionForFileGrouping(interceptionCommand);
        }
        if (this.runBookCostCalc)
        {
            await this.scheduleWAC();
        }
    }

    public setInterceptionToTrue() {
        this.runInterception = true;
        this.runBookCostCalc = false;
    }

    public setBookCostCalcToTrue() {
        this.runInterception = false;
        this.runBookCostCalc = true;
        this.scheduleProcessCommand.meta.endDateRange.value = this.t1;
    }

    public async scheduleWAC(){
        var  response = await this.homeApiClient.scheduleWacCommand(this.scheduleProcessCommand.toJSObject());
        this.scheduleProcessCommand.runWACRollover = true;
        if (response.status === HttpResponseStatusCodeEnum.Success) 
        {
            NotifyUtils.addSuccess(TextConstants.Notifications.ScheduleWAC, `Successfully scheduled WAC for ${this.scheduleProcessCommand.serviceProviderGroupingName}.`, NotificationDuration.Standard);
        }
        else
        {
            NotifyUtils.addWarning(TextConstants.Notifications.SecurityTransferDeleted, `Failed to schedule WAC for ${this.scheduleProcessCommand.serviceProviderGroupingName}.`, NotificationDuration.Standard);
        }
    }

    public async scheduleInterceptionForFileGrouping(command: ScheduleInterceptionCommand) {
        var response = await this.generalApiClient.scheduleInterceptionForServiceProvider(command);
        if (response.status === HttpResponseStatusCodeEnum.Success) 
        {
            NotifyUtils.addSuccess(TextConstants.Notifications.InterceptionInitiated, `Interception for ${this.scheduleProcessCommand.serviceProviderName} scheduled successfully.`, NotificationDuration.Standard);
        }
        else 
        {
            NotifyUtils.addWarning(TextConstants.Notifications.InterceptionFailed, `Failed to schedule interception for ${this.scheduleProcessCommand.serviceProviderName}.`, NotificationDuration.Standard);
        }
    }

    private mapWACCommandToInterceptionCommand(interceptionProcessName: string) {
        var interceptionCommand = new ScheduleInterceptionCommand();
        if (this.scheduleProcessCommand.staticServiceProviderID !== null) {
            interceptionCommand.staticServiceProviderId = this.scheduleProcessCommand.staticServiceProviderID;
            interceptionCommand.interceptionStoredProcedureName = interceptionProcessName;
        }
        return interceptionCommand;
    }
}
